export default __webpack_public_path__ + "static/media/arrow-r.a8033887.svg";